import React from "react";
import { useTranslation } from "react-i18next";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { TransportOrderDetailsDto } from "../../../models/transport/transportOrder";
import Grid2 from "@mui/material/Unstable_Grid2";
import { FormatDetailsContent } from "./formatTransportsUtils";
import { Base } from "../../../framework/common/base";

export interface OrderDetailsProps {
    order: TransportOrderDetailsDto;
}

export const OrderDetails = ({ order }: OrderDetailsProps) => {
    const { t } = useTranslation();

    const getCreatorText = () => {
        return t("common.created") + " " + Base.dateToDateTimeStr(order?.createdDateTime) + " " + order?.createdEmployeeName;
    };

    return (
        <Box
            sx={{ flexDirection: "column", p: 2, mx: 2, mb: 2 }}
            border={1}
            borderRadius={1}
        >
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    width: "100%",
                    mb: 1,
                }}
            >
                <FormatDetailsContent
                    title=""
                    content={getCreatorText()}
                    isInfoText
                />
            </Box>

            {order?.name && (
                <Grid2 container>
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "right",
                            alignItems: "center",
                            width: "100%",
                        }}
                    >
                        {order?.name && (
                            <Typography
                                variant="h4"
                                sx={{
                                    fontWeight: "bold",
                                    color: "success.main",
                                    mb: 1,
                                }}
                            >
                                {order.name}
                            </Typography>
                        )}
                    </Box>
                </Grid2>
            )}

            <Grid2 container>
                <FormatDetailsContent
                    title={t("transport.order.orderNumber")}
                    content={order?.orderNumber}
                />
                {order?.senderName && (
                    <FormatDetailsContent
                        title={t("transport.order.sender")}
                        content={order.senderName}
                        displayAddress={order.senderCustomerId}
                    />
                )}
                {order?.receiverName && (
                    <FormatDetailsContent
                        title={t("transport.order.receiver")}
                        content={order.receiverName}
                        displayAddress={order.receiverCustomerId}
                    />
                )}
                <FormatDetailsContent
                    title={t("transport.order.billingCustomer")}
                    content={order?.billingCustomerName}
                />
            </Grid2>
        </Box>
    );
};
